// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f50cd851","453":"fac8a620","667":"beddac26"}[chunkId] + ".chunk.js";
};